import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useActions } from 'utils/hooks';
import Select from 'common/components/form/inputs/Select';

import * as listActions from 'store/lists/actions';

const VesselsTypesSelector = ({
  filter,
  value,
  onChange,
  isMulti,
  label,
  placeholder,
  className
}) => {
  const [fetchListOptions] = useActions([listActions.fetchListOptions]);
  const vesselTypes = useSelector(state => state.lists['vessel-types']);

  useEffect(() => {
    if (!vesselTypes.options.length && !vesselTypes.isFetching) {
      fetchListOptions('vessel-types');
    }
  }, []);

  return (
    <Select
      label={label}
      className={`vessel-type-selector ${className ? className : ''}`}
      placeholder={placeholder ? placeholder : 'Select value'}
      getOptionValue={option => option.id}
      getOptionLabel={option => option.name}
      value={filter ? (filter.value && Array.isArray(filter.value) ? filter.value : []) : value}
      options={vesselTypes.options}
      isMulti={isMulti}
      onChange={selected =>
        onChange({
          data: selected ? selected : [],
          value: selected ? (isMulti ? selected : selected) : ''
        })
      }
      isClearable
    />
  );
};

export default VesselsTypesSelector;
